module.exports = __webpack_public_path__ + "img/peace.375863c9.svg";